import React from "react"
import avatar from "avatar/poppy-money-ship.png"

const PoppyMoneyShip = (props) => <img src={avatar} className="poppy-money-ship" {...props} />

export default PoppyMoneyShip
